import { queryAddNewCommand, queryDeleteItem, queryList } from './service';

import { toPaginate } from '@/utils/infrastructure';
import _ from 'lodash';

const meta = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const Model = {
  namespace: 'processCustomListCommand',
  state: {
    newCommand: false,
    selectedItem: null,
    formConfig: null,
    list: [],
    pagination: meta,
    select: 'id,command',
    view: false,
    orderBy: '',
    id: null,
    loadingItem: false,
    searchCriteria: '',
  },

  effects: {
    *fetchList({ payload }, { call, put }) {
      try {
        const response = yield call(queryList, payload);
        yield put({
          type: 'queryCommands',
          payload: {
            ...response,
            limit: payload.limit,
            page: payload.page,
          },
        });
      } catch (error) {
        /*  */
      }
    },

    *addNewCommand({ payload }, { put }) {
      yield put({
        type: 'addCommand',
        payload,
      });
      if (!_.isNil(payload.id)) {
        yield put({
          type: 'editOrViewCommand',
          payload,
        });
      }
    },

    *saveNewCommand({ payload }, { call, put }) {
      try {
        const response = yield call(queryAddNewCommand, payload.data);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveCommand',
          payload: response,
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error && error.message) {
          if (
            error.validationErrors &&
            error.validationErrors.length &&
            _.isEmpty(error.validationErrors[0].field)
          ) {
            _.set(error, 'message', error.validationErrors[0].errorMessages[0]);
          }
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },
    *deleteItem({ payload }, { call, put }) {
      try {
        yield put({
          type: `global/modalConfirm`,
          state: false,
          id: null,
        });
        yield call(queryDeleteItem, payload.id);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveCommand',
          payload: {
            state: false,
            item: null,
            view: false,
          },
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: `global/modalConfirm`,
            state: false,
            id: null,
          });
          yield put({
            type: `global/showNotifications${payload.view ? 'Form' : 'Global'}`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: payload.view,
            },
          });
        }
      }
    },

    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'orderBy',
        payload,
      });
    },

    *search({ payload }, { put }) {
      yield put({
        type: payload.type,
        payload: payload.str,
      });
    },

    *hideAllForms({ payload = 'hideForms' }, { put }) {
      yield put({ type: payload });
    },
  },

  reducers: {
    queryCommands(state, { payload }) {
      return {
        ...state,
        list: payload.items,
        pagination: _.merge(state.pagination, toPaginate(payload)),
      };
    },

    addCommand(state, { payload }) {
      return {
        ...state,
        newCommand: payload.state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
      };
    },

    editOrViewCommand(state) {
      return {
        ...state,
        selectedItem: {},
      };
    },

    saveCommand(state, { payload }) {
      return {
        ...state,
        saveCommand: payload,
        newCommand: false,
        selectedItem: false,
      };
    },

    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },
    searchCommands(state, { payload }) {
      return {
        ...state,
        searchCriteria: payload,
      };
    },

    hideForms(state) {
      return {
        ...state,
        newCommand: false,
        selectedItem: null,
        view: null,
        orderBy: '',
        id: null,
        searchCriteria: '',
      };
    },
  },
};

export default Model;
